import { AsyncPipe, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ButtonDirective, ButtonTextDirective, SvgComponent } from '@app/base-components';
import { AppliedPromotionsDisclaimerComponent } from '@app/cart';
import { ButtonQaId, HabaQaId } from '@app/helpers';
import { ProceedService } from '@app/services';
import { ActiveCartService, Cart, I18nModule, RoutingService } from 'haba-core';
import { CheckoutStepService } from 'haba-featurelibs/checkout/components';
import { CheckoutStepType } from 'haba-featurelibs/checkout/root';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HabaCartCouponComponent } from '../../cart/apply-voucher/haba-cart-coupon.component';
import { OrderDetailsListComponent } from '../../cart/cart-shared/order-details-list/order-details-list.component';
import { HabaPlaceOrderComponent } from '../place-order/place-order.component';

@Component({
  selector: 'app-checkout-order-summary',
  templateUrl: './checkout-order-summary.component.html',
  styleUrls: ['checkout-order-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    OrderDetailsListComponent,
    ButtonDirective,
    ButtonTextDirective,
    HabaPlaceOrderComponent,
    SvgComponent,
    AsyncPipe,
    I18nModule,
    HabaCartCouponComponent,
    AppliedPromotionsDisclaimerComponent,
  ],
})
export class CheckoutOrderSummaryComponent implements OnInit, OnDestroy {
  cart$: Observable<Cart>;
  activeStepIndex: number;
  routerSub: Subscription;
  lastStepIndex: number;
  baseId: HabaQaId;
  submitButtonId: ButtonQaId;

  constructor(
    protected activeCartService: ActiveCartService,
    protected checkoutStepService: CheckoutStepService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected routingService: RoutingService,
    private proceedService: ProceedService,
    public ref: ChangeDetectorRef
  ) {
    this.cart$ = this.activeCartService.getActive();
  }

  ngOnInit() {
    this.initIds();
    this.lastStepIndex = this.checkoutStepService.allSteps.length - 1;
    this.setData();
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setData();
        this.ref.markForCheck();
      });
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe();
    this.proceedService.clearCallback();
  }

  setData() {
    this.activeStepIndex = Math.floor(
      this.checkoutStepService.getCurrentStepIndex(this.activatedRoute) || 0
    );
  }

  isAddressPage(): boolean {
    return (
      this.checkoutStepService.allSteps[this.activeStepIndex] ===
      this.checkoutStepService.getCheckoutStep(CheckoutStepType.SHIPPING_ADDRESS)
    );
  }

  goNext() {
    this.proceedService.canProceed().then((value) => {
      if (value) {
        this.checkoutStepService.next(this.activatedRoute);
      }
    });
  }

  private initIds() {
    this.baseId = HabaQaId.forPage(HabaQaId.page.reviewOrder);
    this.submitButtonId = this.baseId.getButtonId(HabaQaId.elements.button.submit);
  }
}
